import fieldMixin from '@maison/mixins/fieldMixin';
import { filter, groupBy } from 'lodash-es';

export default {
  mixins: [fieldMixin],

  props: {
    emptyChoice: {
      type: Boolean,
      default: false,
    },
    preventSelectingUniqueOption: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    selectFieldClasses() {
      return ['field--select', this.fieldClasses];
    },

    hasUniqueOption() {
      return this.field.options !== undefined && this.field.options.length === 1;
    },

    options() {
      return filter(this.field.options, (option) => option.group === undefined);
    },

    groupedOptions() {
      return groupBy(
        filter(this.field.options, (option) => option.group !== undefined),
        'group',
      );
    },
  },

  watch: {
    'field.options': {
      handler() {
        if (this.hasUniqueOption && !this.preventSelectingUniqueOption) {
          this.selectFirstItem();
        }
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
      immediate: true,
    },
  },

  methods: {
    selectFirstItem() {
      this.value = this.field.options[0].value;
    },
  },
};
